import React from 'react';

import './Kulissenpreis.css';
import {
  calculateDelta,
  calculateKulissenpreisJeStueck,
  getDeltaWert,
  getMaxTuple,
  getMinTuple,
  parseKulissenpreisCsv,
} from '../calculations/pricing';

class Kulissenpreis extends React.Component {
    constructor(props) {
    super(props);
    this.state = {
             daten: [],
             d32hz: 0,
             d63hz: 0,
             d125hz :0,
             d250hz :0,
             d500hz :0,
             d1000hz :0,
             d2000hz : 0,
             d4000hz : 0,
             d8000hz :0 ,
    };
    }

    // daten = [];
    // datastring = '';
    getDaten(Dname){

        let d = calculateKulissenpreisJeStueck({
            kulissenpreisDaten: this.state.daten,
            Kulissenhoehe: this.props.Kulissenhoehe,
            Kulissenlaenge: this.props.Kulissenlaenge,
            Kulissentyp: this.props.Kulissentyp,
            Kulissenbreite: this.props.Kulissenbreite,
        });
        // console.log("Folie: " + this.props.Optionen[0].isChecked)
        // this.props.KulissenpreisChange(d);

        // //Zusatzoptionen der Kulissen
        // if(d > 0){
        //     // Zusatzoptionen
        //     if(this.props.Optionen[0].isChecked){
        //         // Option: Kulissen in Folie
        //         // Kulissenpreis * 1.2
        //         d = d*1.2;
        //
        //     }
        //     if(this.props.Optionen[1].isChecked){
        //         // Option: Führungsschienen
        //         // 16€ pro laufender Meter Kulissenlänge
        //         d = d + (Math.sqrt(this.props.Kulissenbreite) * this.props.Kulissenlaenge /1000 * 16);
        //
        //     }
        //     if(this.props.Optionen[2].isChecked){
        //         //Option: Anströmkalotten einseitig V-Form
        //         //8€ pro laufender Meter Kulissenhöhe
        //         d = d + (Math.sqrt(this.props.Kulissenbreite) * this.props.Kulissenhoehe /1000 * 16);// / 1000 = mm zu m tranformieren
        //     }
        //
        // }

        this.props.KulissenpreisChange(d);

        // this.props.KulissenpreisChange(d);
        return d;
    }



async componentDidMount(){

       //const request = await fetch('http://localhost:3000/kulissenpreis.csv');
       const request = await fetch('../kulissenpreis.csv');
       const datastring = await request.text();

        //console.log("Nr.: "+parseKulissenpreisCsv(datastring)[0]["125"]);
        this.datastring = datastring;
        let daten = [];
        daten = await this.csvJSON(datastring);
        //this.daten = await this.csvJSON(datastring);


        this.setState({daten : daten});
  }


  getDelta(x,y){
      return calculateDelta(x, y);
  }

  getMinTuple(daten,XSoll,YSoll,Xname,Yname, Muss1, Muss2){
      return getMinTuple(daten, XSoll, YSoll, Xname, Yname, Muss1, Muss2);
  }
  getMaxTuple(daten,XSoll,YSoll,Xname,Yname, Muss1, Muss2){
      return getMaxTuple(daten, XSoll, YSoll, Xname, Yname, Muss1, Muss2);
  }


  getDeltaWert(daten ,xSoll, ySoll,Xname,Yname,Dname,musskriterium1,musskriterium2){
        return getDeltaWert(daten, xSoll, ySoll, Xname, Yname, Dname, musskriterium1, musskriterium2);
  }


  csvJSON(csv){
        return parseKulissenpreisCsv(csv);
}



  render() {
        // console.log("Datenlänge: "+this.state.daten.length);
      this.getDaten("Preis");
      return null;

    // return (
    //     <>
    //          {/*<td>{this.getDeltaWert(this.props.Einfuegedaempfungsdaten ,xSoll,ySoll,Xname,Yname,'250')}</td>*/}
    //         {/*<td>{this.getDaten("Preis").toFixed(2)}</td>*/}
    //         {/* <td>{this.getDaten("63").toFixed(2)}</td>*/}
    //         {/*<td>{this.getDaten("125").toFixed(2)}</td>*/}
    //         {/*<td>{this.getDaten("250").toFixed(2)}</td>*/}
    //         {/*<td>{this.getDaten("500").toFixed(2)}</td>*/}
    //         {/*<td>{this.getDaten("1000").toFixed(2)}</td>*/}
    //         {/*<td>{this.getDaten("2000").toFixed(2)}</td>*/}
    //         {/*<td>{this.getDaten("4000").toFixed(2)}</td>*/}
    //         {/*<td>{this.getDaten("8000").toFixed(2)}</td>*/}
    //
    //     </>);


  }
}
export default Kulissenpreis;
